module.exports = __webpack_public_path__ + "340db72b8d2d228dfdac24be7abe1713.jpg";